import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HomePage } from "@/pages/HomePage";
import { CategoryPage, SearchPage } from "@/pages/CategoryPage";
import { ListsPage, ListDetailPage } from "@/pages/ListPage";
import { ProductPage, DisclosurePage } from "@/pages/ProductPage";
import { BlogPage, BlogDetailPage } from "@/pages/BlogPage";
import { AdminLoginPage } from "@/pages/AdminLogin";
import { AdminLayout } from "@/pages/AdminLayout";
import { AdminDashboard, AdminProducts, AdminLists, AdminSettings, AdminPosts } from "@/pages/AdminPages";
import { AdminSEO } from "@/pages/AdminSEO";
import { AdminComparisons } from "@/pages/AdminComparisons";
import { AdminLinks } from "@/pages/AdminLinks";
import { AdminAnalytics } from "@/pages/AdminAnalytics";
import { CompareIndexPage, CompareDetailPage } from "@/pages/ComparePage";
import { GoRedirectPage } from "@/pages/GoRedirect";
import { UnsubscribePage } from "@/pages/Unsubscribe";

function PublicShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1">{children}</div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<PublicShell><HomePage /></PublicShell>} />
            <Route path="/lists" element={<PublicShell><ListsPage /></PublicShell>} />
            <Route path="/list/:id" element={<PublicShell><ListDetailPage /></PublicShell>} />
            <Route path="/blog" element={<PublicShell><BlogPage /></PublicShell>} />
            <Route path="/blog/:id" element={<PublicShell><BlogDetailPage /></PublicShell>} />
            <Route path="/category/:name" element={<PublicShell><CategoryPage /></PublicShell>} />
            <Route path="/product/:id" element={<PublicShell><ProductPage /></PublicShell>} />
            <Route path="/search" element={<PublicShell><SearchPage /></PublicShell>} />
            <Route path="/compare" element={<PublicShell><CompareIndexPage /></PublicShell>} />
            <Route path="/compare/:slug" element={<PublicShell><CompareDetailPage /></PublicShell>} />
            <Route path="/go/:slug" element={<GoRedirectPage />} />
            <Route path="/alerts/unsubscribe" element={<PublicShell><UnsubscribePage /></PublicShell>} />
            <Route path="/disclosure" element={<PublicShell><DisclosurePage /></PublicShell>} />
            <Route path="/admin/login" element={<PublicShell><AdminLoginPage /></PublicShell>} />
            <Route path="/admin" element={<PublicShell><AdminLayout /></PublicShell>}>
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="lists" element={<AdminLists />} />
              <Route path="posts" element={<AdminPosts />} />
              <Route path="comparisons" element={<AdminComparisons />} />
              <Route path="links" element={<AdminLinks />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="seo" element={<AdminSEO />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
